var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "confirm-modal-backdrop" }, [
    _c("div", { staticClass: "confirm-modal center-align" }, [
      _c("div", { staticClass: "mb-2" }, [
        _vm._v(_vm._s(_vm.$t(`${_vm.message}`))),
      ]),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "add-button mr-2",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.confirm()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("yes")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "remove-button",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("no")) + " ")]
        ),
      ]),
    ]),
    _c("div", {
      staticClass: "ourside-confirm-modal",
      on: {
        click: function ($event) {
          return _vm.cancel()
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }